import React, { Component } from 'react'

export default class TheFooter extends Component {
    render() {
        return (
            <div>
                &copy;Creted by Codiotic
            </div>
        )
    }
}
